import { HeaderFixed } from '@/components';
import { JarFilterButtons } from './JarFilterButtons';
import { JarSearchBox } from './JarSearchBox';
import { JarHeaderSubscriptions } from './JarHeaderSubscriptions';
import { JarHeaderUnauthenticated } from './JarHeaderUnauthenticated';
import { useContext } from 'react';
import AuthenticationContext from '@/context/AuthenticationContext';

export const JarHeader: React.FC = () => {
  const { isAuthenticated } = useContext(AuthenticationContext);

  return (
    <HeaderFixed animatedShadow>
      {isAuthenticated ? <JarHeaderSubscriptions /> : <JarHeaderUnauthenticated />}
      <JarSearchBox />
      <JarFilterButtons />
    </HeaderFixed>
  );
};
